import type { NavMegaMenuId } from './navMenuConfig';

export type NavPrimaryLink = {
  label: string;
  href: string;
  cmsKey: string;
  megaMenu?: NavMegaMenuId;
  showOnlyMobile?: boolean;
};

export const NAV_PRIMARY_LINKS: NavPrimaryLink[] = [
  {
    label: 'Profile Area',
    href: '/Profile-area',
    cmsKey: 'navigation.profileArea',
    showOnlyMobile: true,
  },
  {
    label: 'About',
    href: '/about',
    cmsKey: 'navigation.about',
  },
  {
    label: 'Tools',
    href: '/Tools',
    cmsKey: 'navigation.tools',
    megaMenu: 'tools',
  },
  {
    label: 'Docs',
    href: '/docs',
    cmsKey: 'navigation.docs',
    megaMenu: 'docs',
  },
  {
    label: 'Insights',
    href: '/insights',
    cmsKey: 'navigation.insights',
    megaMenu: 'insights',
  },
  {
    label: 'Pricing',
    href: '/plans',
    cmsKey: 'navigation.pricing',
  },
];

/** @deprecated Use NAV_PRIMARY_LINKS */
export const NAVIGATION_LINKS = NAV_PRIMARY_LINKS;
